import { useState, useEffect } from 'react';
import Layout from '../Components/Layout/Layout';
import DishesList from '../Components/Dishes/DishesList';
import { Button } from "@/Components/ui/button";
import { Plus } from "lucide-react";
import { ChevronRight , QrCode } from "lucide-react";
import axiosInstance from '../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';


import icon1 from '../images/allergens/1.webp';
import icon3 from '../images/allergens/3.webp';
import icon4 from '../images/allergens/4.webp';
import icon5 from '../images/allergens/5.webp';
import icon11 from '../images/allergens/11.webp';
import icon12 from '../images/allergens/12.webp';
import icon16 from '../images/allergens/16.webp';
import icon17 from '../images/allergens/17.webp';
import icon19 from '../images/allergens/19.webp';
import icon21 from '../images/allergens/21.webp';
import icon22 from '../images/allergens/22.webp';
import icon23 from '../images/allergens/23.webp';
import icon24 from '../images/allergens/24.webp';
import icon26 from '../images/allergens/26.webp';
import empty from '../images/allergens/empty.png';

import icon1b from '../images/dieets/1.png';
import icon2b from '../images/dieets/2.png';
import icon3b from '../images/dieets/3.png';
import icon4b from '../images/dieets/4.png';
import icon5b from '../images/dieets/5.png';
import icon6b from '../images/dieets/6.png';
import icon7b from '../images/dieets/7.png';
import icon8b from '../images/dieets/8.png';
import icon9b from '../images/dieets/9.png';
import icon10b from '../images/dieets/10.png';


const allergenIcons = {
    1: icon1,
    3: icon3,
    4: icon4,
    5: icon5,
    11: icon11,
    12: icon12,
    16: icon16,
    17: icon17,
    19: icon19,
    21: icon21,
    22: icon22,
    23: icon23,
    24: icon24,
    26: icon26,
};
const dietaryIcons = {
    1: icon1b,
    2: icon2b,
    3: icon3b,
    4: icon4b,
    5: icon5b,
    6: icon6b,
    7: icon7b,
    8: icon8b,
    9: icon9b,
    10: icon10b
};

const Result = () => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDishes = async () => {
            try {
                setIsLoading(true);
                const response = await axiosInstance.get('/menu/GetCompleteMenu');
                const data = await response.data; 
                try {
                    setCategories(data);
                } catch (e) {
                    console.error('Unexpected API response format:', data);
                    setCategories([]);
                }
            } catch (error) {
                console.error('Error fetching dishes:', error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchDishes();
    }, []);
     

    if (isLoading) return <Layout><div>Loading...</div></Layout>;
    if (error) return <Layout><div>Error: {error}</div></Layout>;

    return (
        <Layout>
            <div className="relative">
                <div className="space-y-8">
                    {Array.isArray(categories) && categories.length > 0 ? (
                        categories.some(category => category?.dishes?.length > 0) ? (
                            categories.map((category) => (
                                // Add null check for category and category.name
                                category?.dishes?.length > 0 && category?.name && (
                                    <div key={category.id || `category-${Math.random()}`} className="mb-4">
                                        <h3 className="text-xl font-inter text-ps-blue-dark mb-0 mt-4 font-bold">{category.name}</h3>
                                        <span className="font-inter text-ps-blue-dark font-light">{category.description}</span>
                                        <div className="space-y-2 mt-2">
                                            {category.dishes.map((dish) => (
                                                <>
                                                    <div
                                                        key={dish.id || `dish-${Math.random()}`}
                                                        className="flex items-center justify-between w-full p-4 pb-0">
                                                        <span className="font-inter text-ps-blue-dark font-bold text-base ">{dish.name}</span>

                                                        <div className="flex items-center gap-6">
                                                            <div className="flex text-black font-inter">
                                                                <span className="mr-1">&euro;</span>
                                                                <span className="w-12 text-right">
                                                                    {(dish.price || 0).toFixed(2)}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="w-full pl-4 pb-0">
                                                        <span className="font-inter text-ps-blue-dark font-extralight">{dish.description}</span>
                                                    </div>
                                                    {dish.allergens && (
                                                        <div className="w-full pl-4">
                                                            <div className="flex items-center gap-2">
                                                                <span className="font-inter text-ps-blue-dark font-extralight text-xs">Allergen</span>
                                                                {dish.allergens
                                                                    .filter(allergen => allergenIcons[allergen.id])
                                                                    .map((allergen) => (
                                                                        <div key={allergen.id} className="inline-flex items-center">
                                                                            <img
                                                                                src={allergenIcons[allergen.id]}
                                                                                alt={allergen.name}
                                                                                title={allergen.name}
                                                                                className="w-6 h-6"
                                                                                onClick={() => alert(allergen.name)}
                                                                            />
                                                                        </div>
                                                                    )
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {dish.dietaryneeds && (
                                                        <div className="w-full pl-4">
                                                            <div className="flex items-center gap-2">
                                                                <span className="font-inter text-ps-blue-dark font-extralight text-xs">Dieet wensen</span>
                                                                {dish.dietaryneeds
                                                                    .filter(dietaryneed => dietaryIcons[dietaryneed.id])
                                                                    .map((dietaryneed) => (
                                                                        <div key={dietaryneed.id} className="inline-flex items-center">
                                                                            <img
                                                                                src={dietaryIcons[dietaryneed.id]}
                                                                                alt={dietaryneed.name}
                                                                                title={dietaryneed.name}
                                                                                className="w-6 h-6"
                                                                                onClick={() => alert(dietaryneed.name)}
                                                                            />
                                                                        </div>
                                                                    )
                                                                    )}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="w-full pl-3 pb-3">
                                                        <span className="font-inter text-ps-blue-dark font-extralight text-xs"></span>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                )
                            ))
                        ) : (
                            <div className="text-center py-8 text-gray-500 font-inter">
                                Er zijn geen gerechten gevonden in het geselecteerde menu, controleer of de categorieen en gerechten gepubliceerd zijn.
                            </div>
                        )
                    ) : (
                        <div className="text-center py-8 text-gray-500 font-inter">
                                Er zijn geen gerechten gevonden in het geselecteerde menu, controleer of de categorieen en gerechten gepubliceerd zijn.
                        </div>
                    )}
                </div>
                <center className="pt-8">
                    <Button
                        className={`w-full bg-ps-orange  hover:opacity-75 text-white w-80 align-center h-[50px] mb-10`} onClick={() => navigate('/qr-code')}
                    >
                        <QrCode className="mr-2" size={20} />
                        Genereer QR code
                    </Button></center> 
            </div>
        </Layout>
    ); 
};

export default Result;